//Service Provider Codes
export const UberSPCode = "100";
export const SmartziSPCode = "200";
